module.exports = __webpack_public_path__ + "img/22.d929b74b.png";